// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ProcessingMethod {
  ProcessAll = "PROCESS_ALL",
  ProcessSelected = "PROCESS_SELECTED",
}
export default ProcessingMethod;
